var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRejectedCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24.5,
    fill: "#FFF0EF",
    stroke: "#FF675C",
    strokeDasharray: "4 4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6516 23.6516C27.9445 23.3588 27.9445 22.8839 27.6516 22.591C27.3588 22.2981 26.8839 22.2981 26.591 22.591L25 24.182L23.409 22.591C23.1161 22.2981 22.6412 22.2981 22.3483 22.591C22.0555 22.8839 22.0555 23.3588 22.3483 23.6517L23.9393 25.2426L22.3483 26.8336C22.0555 27.1265 22.0555 27.6014 22.3483 27.8943C22.6412 28.1872 23.1161 28.1872 23.409 27.8943L25 26.3033L26.591 27.8943C26.8839 28.1872 27.3588 28.1872 27.6517 27.8943C27.9445 27.6014 27.9445 27.1265 27.6517 26.8336L26.0607 25.2426L27.6516 23.6516Z",
    fill: "#FF675C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 14.25C19.0629 14.25 14.25 19.0629 14.25 25C14.25 30.9371 19.0629 35.75 25 35.75C30.9371 35.75 35.75 30.9371 35.75 25C35.75 19.0629 30.9371 14.25 25 14.25ZM15.75 25C15.75 19.8914 19.8914 15.75 25 15.75C30.1086 15.75 34.25 19.8914 34.25 25C34.25 30.1086 30.1086 34.25 25 34.25C19.8914 34.25 15.75 30.1086 15.75 25Z",
    fill: "#FF675C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectedCircle);
export default __webpack_public_path__ + "static/media/RejectedCircle.baea523cc98b861865d40795fd67f23b.svg";
export { ForwardRef as ReactComponent };